/********************************************* ASSETS *********************************************/
const s = require('../auth-landing-footer.scss');

/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import cn from 'classnames';
import {inject} from 'mobx-react';

/**************************************** PROJECT MODULES *****************************************/
import {translate, ConfigProps} from '@canimmunize/core-imports';

/**************************************** TYPE DEFINITIONS ****************************************/
interface ChangeLanguageButtonViewProps extends ConfigProps {
    onClick: EventHandler;
}

/********************************************* EXPORT *********************************************/
/**
 * Pre-login footer link to change the current language
 */
export const ChangeLanguageButtonView = inject('config')(
    (props?: ChangeLanguageButtonViewProps) => {
        return (
            <a
                id={props.config.elementIds.auth.footer.changeLanguageButton}
                className={cn(s[`footer-link`], `ml-2p`)}
                href={`javascript:null;`}
                onClick={props.onClick}
            >
                {translate(`other_canada_lang`, null, `metadata.`).capitalize}
            </a>
        );
    }
);

ChangeLanguageButtonView.displayName = `ChangeLanguageButtonView`;
